module.exports = __webpack_public_path__ + "static/media/Alyssa Weis.ba6ae9ba.png";